import { z } from 'zod';

// The CSP allows no eval (SDD §12.5). Without this, zod probes `new Function` once, and the browser
// reports the blocked probe as a CSP violation even though zod catches it and works without it.
// Imported first by main.tsx, so it is set before any module parses anything.
z.config({ jitless: true });
